/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * カレンダマスタ検索情報
 */
export interface CalendarMasterSearchInfo { 
    /**
     * カレンダコード：英数字
     */
    calendarCode: string;
    /**
     * 年：数字
     */
    year?: string | null;
    /**
     * 月：数字
     */
    month?: string | null;
    /**
     * 日：数字
     */
    date?: string | null;
}

